import { VimeoIcon, youTubeIcon, modernAudioPlaylistIcon, classicAudioPlaylistIcon, cardAudioPlaylistIcon, dPlayerIcon, advanceAudioPlaylistIcon, advanceVideoPlayerIcon, artPlayerIcon, html5AudioIcon, html5videoIcon, advanceAudioPlayerIcon, audioPlaylistIcon, videoPlaylistIcon, classicVideoPlaylistIcon } from './blocksIcon';

const pluginSlug = 'media-player-addons-for-elementor';

const siteURL = 'https://elementor.bplugins.com';
const demoLink = `${siteURL}/demo`;
const docsURL = `https://bplugins.com/docs/media-player-addons-for-elementor/widget-guides/`;

export default [

    {
        name: `mpafe_youtube_video_player`,
        title: 'YouTube Video Player',
        icon: youTubeIcon,
        demo: `${demoLink}/youtube-video-player/`,
        docs: `${docsURL}`,
    },
    {
        name: `mpafe_vimeo_video_player`,
        title: 'Vimeo Video Player',
        icon: VimeoIcon,
        demo: `${demoLink}/vimeo-video-player/`,
        docs: `${docsURL}`,
    },
    {
        name: `mpafe_html5_audio_player`,
        title: 'HTML5 Audio Player',
        icon: html5AudioIcon,
        demo: `${demoLink}/html5-audio-player/`,
        docs: `${docsURL}`,
    },
    {
        name: `mpafe_html5_video_player`,
        title: 'HTML5 Video Player',
        icon: html5videoIcon,
        demo: `${demoLink}/html5-video-player/`,
        docs: `${docsURL}`,
    },
    {
        name: `mpafe_art_video_player`,
        title: 'Art Player',
        icon: artPlayerIcon,
        demo: `${demoLink}/art-player-video-player/`,
        docs: `${docsURL}`,
    },
    {
        name: `mpafe_advance_audio_player`,
        title: 'Advance Audio Player',
        icon: advanceAudioPlayerIcon,
        demo: `${demoLink}/advance-audio-player/`,
        docs: `${docsURL}`,
    },
    {
        name: `mpafe_advance_video_player`,
        title: 'Advance Video Player',
        icon: advanceVideoPlayerIcon,
        demo: `${demoLink}/advance-video-player/`,
        docs: `${docsURL}`,
    },
    {
        name: `mpafe_dplayer_video_player`,
        title: 'dPlayer',
        icon: dPlayerIcon,
        demo: `${demoLink}/dplayer-video-player/`,
        docs: `${docsURL}`,
    },
    {
        name: `mpafe_audio_player_playlist`,
        title: 'Audio Player Playlist',
        icon: audioPlaylistIcon,
        demo: `${demoLink}/audio-player-playlist/`,
        docs: `${docsURL}`,
    },
    {
        name: `mpafe_video_player_playlist`,
        title: 'Video Player Playlist',
        icon: videoPlaylistIcon,
        demo: `${demoLink}/advance-video-player-playlist/`,
        docs: `${docsURL}`,
    },
    {
        name: `mpafe_advance_audio_player_playlist`,
        title: 'Advance Audio Playlist',
        icon: advanceAudioPlaylistIcon,
        demo: `${demoLink}/advance-audio-playlist/`,
        docs: `${docsURL}`
    },
    {
        name: `mpafe_classic_audio_player_playlist`,
        title: 'Classic Audio Playlist',
        icon: classicAudioPlaylistIcon,
        demo: `${demoLink}/classic-audio-playlist-light/`,
        docs: `${docsURL}`,
        isPremium: true
    },
    {
        name: `mpafe_classic_video_player_playlist`,
        title: 'Classic Video Playlist',
        icon: classicVideoPlaylistIcon,
        demo: `${demoLink}/classic-video-player-playlist/`,
        docs: `${docsURL}`,
        isPremium: true
    },
    {
        name: `mpafe_card_audio_playlist`,
        title: 'Card Audio Playlist',
        icon: cardAudioPlaylistIcon,
        demo: `${demoLink}/card-audio-playlist/`,
        docs: `${docsURL}`,
        isPremium: true
    },
    {
        name: `mpafe_modern_audio_playlist`,
        title: 'Modern Audio Playlist',
        icon: modernAudioPlaylistIcon,
        demo: `${demoLink}/modern-audio-playlist/`,
        docs: `${docsURL}`,
        isPremium: true
    }
];